import request from '@/utils/http-util'
import { baseUrl } from '/env'

export function pageListApi(params) {
    return request({
        url: baseUrl+'/datasetSql/pageList',
        method: 'get',
        params
    })
}

export function saveOrUpdateApi(data) {
    return request({
        url: baseUrl+'/datasetSql/saveOrUpdate',
        method: 'post',
        data
    })
}

export function delApi(id) {
    return request({
        url: baseUrl+'/datasetSql/del/'+id,
        method: 'delete'
    })
}
export function doSqlApi(data) {
    return request({
        url: baseUrl+'/datasetSql/doSql',
        method: 'post',
        data
    })
}

export function getDetailApi(id) {
    return request({
        url: baseUrl+'/datasetSql/getDetail?id='+id,
        method: 'get'
    })
}